import React from 'react';
import ReactDOM from 'react-dom';
import 'sass/components/forms.scss';
import 'sass/pages/live_rent_free.scss';
import progressiveLoader from '../../components/progressive_image_loader';
import SharePanel from './share_panel';
import trackEvent from '../../helpers/gtm/eventPush';

const lrfBanner = document.querySelector('#enter_button');

if (lrfBanner) {
  lrfBanner.addEventListener('click', () => {
    trackEvent({
      category: 'call to action',
      action: 'live_rent_free_enter',
      label: `${window._sr.page.loginReturnPath}`,
    });
  });
}

const mountElement = document.getElementById('share');
const shareUrlElement = document.querySelector('meta[property="og:url"]');
const shareUrl = shareUrlElement ? shareUrlElement.content : null;
if (document.querySelector('.lrf__hero')) {
  document.addEventListener('DOMContentLoaded', () => {
    progressiveLoader(`/img/liverentfree/LRF_hero.png`, '.lrf__hero');
  });
}

if (mountElement && shareUrl) {
  const utmCampaign = mountElement.dataset.socialShareUtm;
  const title = mountElement.dataset.socialShareTitle;
  ReactDOM.render(
    <SharePanel
      iconSize={32}
      utmCampaign={utmCampaign}
      shareUrl={shareUrl}
      title={title}
      shareText={true}
    />,
    mountElement,
  );
}

(function persistAndSetCouponValue() {
  const urlParams = new URLSearchParams(window.location.search);
  const couponValue = urlParams.get('extra_entry_code')
    ? urlParams.get('extra_entry_code').replace(/[^a-z0-9áéíóúñü .,_-]/gim, '')
    : false;

  const couponInput = document.querySelector('.lrf__coupon-form-input');
  const couponLink = document.querySelector('.lrf__coupon-link');

  if (couponLink) {
    const { hostname, protocol } = window.location;
    const couponLinkUrl = new URL(
      `liverentfree/coupons${
        couponValue ? `?extra_entry_code=${couponValue}` : ''
      }`,
      `${protocol}//${hostname}`,
    );
    couponLink.href = couponLinkUrl;
  }

  if (couponInput && couponValue) {
    couponInput.value = couponValue;
  }
})();
